import React from 'react'
import hide from "../../images/hide.png"

const ChangePassword = () => {
    return (
        <div className="login-cover change-password">
            <div className="login-box">
                <h1>Choose a new password</h1>
                <p>Please choose a new password.</p>
                <form>
                    <div className="form-group">
                        <label>Password</label>
                        <div className="hide-icon"> 
                            <input type="password" name="email" className="form-control"/>  
                            <img src={hide} alt="logo" /> 
                        </div>                     
                    </div>
                    <div className="form-group">
                        <label>Confirm Password</label>
                        <div className="hide-icon"> 
                            <input type="password" name="email" className="form-control"/>  
                            <img src={hide} alt="logo" /> 
                        </div>                      
                    </div>
                    <div className="reset-password-btn">
                        <button>Reset password</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ChangePassword
